import React, { Component } from 'react';
import Projects from './Projects';
import SocialProfiles from './SocialProfiles';
import Title from './title';
import ABE from '../assets/abePic.jpg';
import Technologies from './Technologies';
import Profiles from './Profiles';
import Testimonials from './Testimonials';


class App extends Component {
    state = { displayBio: false };

    toggleDisplayBio = () => {
        this.setState({ displayBio: !this.state.displayBio });
    }
    render() {
        return (
            <div>

                <div className="parent">
                </div>
                
                <Technologies />
                <hr />
                <Projects />
                
                <Profiles />
                <hr />
                <Testimonials />
                
                <SocialProfiles />
                
                    
                <hr />
            </div>
        )
    }
}

export default App;